import { InsuranceModule } from './../insurance/insurance.module';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { MessageModule } from './../message/message.module';
import { TeamModule } from './../team/team.module';
import { TaskModule } from './../task/task.module';
import { MemberListComponent } from './member-list/member-list.component';
import { MemberListService } from '../core/service/grid-data/grid-data-member.service';
import { NotesModule } from '../notes/notes.module';
import { ContactHistoryModule } from '../contact-history/contact-history.module';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { FlagModule } from '../flag/flag.module';
import { DropDownListFilterModule } from '../shared/dropdownlist/dropdownlist.module';
import { DocumentModule } from '../document/document.module';
import { AssessmentFulfillmentListService } from '../core/service/grid-data/grid-data-assessment-fulfillment.service';
import { FormlyCustomModule } from '../formly/formly.module';
import { FormlyModule } from '@ngx-formly/core';
import { PatientEditModule } from '../shared/patient-edit/patient-edit.module';
import { InsuranceListService } from '../core/service/grid-data/grid-data-insurance.service';
import { MemberSendSelectionModule } from '../shared/member-send-selection/member-send-selection.module';
import { MemberAssessmentModule } from '../shared/member-assessment/member-assessment.module';

@NgModule({
  imports: [
    SharedModule,
    FormlyModule,
    FormlyCustomModule,
    MessageModule,
    FlagModule,
    TaskModule,
    NotesModule,
    ContactHistoryModule,
    ChartsModule,
    DropDownListFilterModule,
    DocumentModule,
    TeamModule,
    MemberAssessmentModule,
    PatientEditModule,
    MemberSendSelectionModule,
    InsuranceModule,
    MemberAssessmentModule
  ],
  exports: [
    MemberListComponent
  ],
  declarations: [
    MemberListComponent
  ],
  providers: [
    MemberListService,
    AssessmentFulfillmentListService,
    InsuranceListService
  ],
})
export class MemberModule { }
